import { MediaTableProps } from "./MediaTableProps";
import { TableRow } from "@kaltura/mediaspace-shared-styled";
import { columnsMap } from "./columns";
import { CellSkeleton } from "./CellSkeleton";
import { StyledActionsContainer, StyledActionsTableCell, StyledTableCell } from "./styled";

export const MediaTableSkeleton = ({
    columns,
    showExploreButton,
    showActionsColumn,
    showRowActions,
    stickyActionsWidth,
}: Pick<MediaTableProps, "columns" | "showExploreButton" | "stickyActionsWidth"> & {
    showActionsColumn: boolean;
    showRowActions: boolean;
}) => {
    return (
        <>
            {Array(5)
                .fill(0)
                .map((_, index) => (
                    <TableRow key={index}>
                        {columns.map((columnId) => (
                            <StyledTableCell key={columnId} columnId={columnId}>
                                {columnsMap[columnId].skeleton ?? <CellSkeleton variant={"rectangular"} />}
                            </StyledTableCell>
                        ))}
                        {showActionsColumn && (
                            <StyledActionsTableCell stickyColumn={true} stickyWidth={stickyActionsWidth}>
                                <StyledActionsContainer>
                                    {showExploreButton && (
                                        <CellSkeleton variant={"rectangular"} width={32} height={32} />
                                    )}

                                    {showRowActions && <CellSkeleton variant={"rectangular"} width={64} height={32} />}
                                </StyledActionsContainer>
                            </StyledActionsTableCell>
                        )}
                    </TableRow>
                ))}
        </>
    );
};
